import React, { useState, useEffect, useRef } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./update_pages.css";
import Select from "react-select";
import "../../Api/apiUrls";
import { UpdateAdminPages, updateTermsAndConditions } from "../../Api/apiUrls";
function Update_TermsCondition({ onClose, policyId, Policy }) {
  const [
    modalUpdate_TermsConditionIsOpen,
    setUpdate_TermsConditionModalIsOpen,
  ] = useState(false);
  const [newPolicy, setNewPolicy] = useState(Policy);

  const [isUpdatingPolicy, setIsUpdatingPolicy] = useState(false);
  const closeUpdate_TermsCondition = () => {
    setUpdate_TermsConditionModalIsOpen(false);
  };
  // console.log(PagesName, PagesTittle, PagesDescription, PagesStatus);

  function reloadPage() {
    window.location.reload();
  }
  function reloadPage() {
    window.location.reload();
  }

  const handleClick = (e) => {
    if (e.currentTarget === e.target) {
      onClose();
      reloadPage();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [handleClick]);
  const handleUpdate = () => {
    setIsUpdatingPolicy(true);

    const formData = new FormData();
    formData.append("terms_and_conditions_id", policyId);

    formData.append("terms_and_conditions", newPolicy);

    fetch(
      `${updateTermsAndConditions}`,
      {
        method: "PUT",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          alert("Updated");
          setIsUpdatingPolicy(false);

          window.location.reload();
          onClose();
        } else {
          console.error("Error updating privacy policy:", data.message);
          setIsUpdatingPolicy(false);
        }
      })
      .catch((error) => {
        console.error("Error updating privacy policy:", error);
        setIsUpdatingPolicy(false);
      });
  };
  return (
    <div>
      {modalUpdate_TermsConditionIsOpen && (
        <Update_TermsCondition onClose={closeUpdate_TermsCondition} />
      )}
      <div className="popup-background" onClick={handleClick}>
        <div className="popup">
          <div
            class="modal-content"
            style={{
              width: "100%",
              height: "80",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
            }}
          >
            <div
              class="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                class="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Update Terms Conditions</b>
              </h5>

              <button
                type="button"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              class="modal-body"
              style={{ overflowY: "scroll", padding: "2%" }}
            >
              <form>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Policy
                  </label>
                  <textarea
                    type="text"
                    style={{ height: "100px" }}
                    id="selectedImg"
                    class="form-control"
                    value={newPolicy}
                    onChange={(e) => setNewPolicy(e.target.value)}
                  />
                </div>
              </form>
            </div>

            <div
              class="modal-footer"
              style={{
                padding: "2%",
                marginTop: "3%",
                borderTop: "solid 1px #7e7a7a8c",
              }}
            >
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
              >
                Close
              </button>

              {isUpdatingPolicy === true ? (
                <div>
                  <ThreeDots color="#000" height={50} width={50} />
                </div>
              ) : (
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  onClick={handleUpdate}
                  style={{ background: "#000 ", border: "none" }}
                >
                  Update
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Update_TermsCondition;
